// Minimal imports - most functionality moved to islands
import { setupPageHeaderGhost } from './utils/page-header-ghost.js';
import { isTouchPrimaryDevice, HOVER_CAPABLE_LAYOUT } from './utils/media.js';

// ========================================
// LCP Performance Monitoring (Development Only)
// ========================================
if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    try {
        const lcpObserver = new PerformanceObserver((entryList) => {
            const entries = entryList.getEntries();
            const lastEntry = entries[entries.length - 1];
            const lcpTime = lastEntry.renderTime || lastEntry.loadTime;
            const element = lastEntry.element;
            const elementInfo = element ? {
                tag: element.tagName,
                id: element.id || '',
                classes: element.className || '',
                src: element.src || element.currentSrc || '',
                text: element.textContent?.substring(0, 50) || ''
            } : 'unknown';
            
            console.group(`LCP #${entries.length}: ${lcpTime}ms`);
            console.log('Element:', elementInfo);
            console.log('Size:', lastEntry.size);
            console.log('Full entry:', lastEntry);
            console.groupEnd();
        });
        lcpObserver.observe({ entryTypes: ['largest-contentful-paint'] });
    } catch (e) {
        // PerformanceObserver not supported
    }
}

// ========================================
// CRITICAL INITIALIZATION (Synchronous)
// These must run immediately to prevent FOUC
// ========================================

// Detect Firefox
const isFirefox = navigator.userAgent.includes("Firefox");

// Add class "is-firefox" to </body>
if (isFirefox) {
    document.body.classList.add("is-firefox");
}




// =======================================================================================
// Detect touch device (do not remove!!!)
// Uses utils/media.js — maxTouchPoints + pointer/hover media queries (no legacy APIs).
// =======================================================================================

const isMobile = isTouchPrimaryDevice();
window.isMobile = isMobile;

if (isMobile) {
    document.body.classList.add("is-mobile");
}





// Page transitions moved to islands/page-transitions.js









// Navigation/menu moved to islands/navigation.js






	// =====================================================
	// Image Gallery - moved to components/image-gallery.js
	// =====================================================



// ================================================================
// Page header
// ================================================================

// If page header exist
// =====================
if (document.getElementById("page-header")) {
    document.body.classList.add("page-header-on");
  
    // If full height enabled
    if (document.getElementById("page-header").classList.contains("ph-full")) {
      document.body.classList.add("ph-full-on");
    }
  
    // If position center enabled
    if (document.getElementById("page-header").classList.contains("ph-center")) {
      document.body.classList.add("ph-center-on");
    }
  
    // If page header image exist
    if (document.querySelector(".ph-image")) {
      document.body.classList.add("ph-image-on");
  
      // If page header image is background image
      if (document.getElementById("page-header").classList.contains("ph-bg-image")) {
        document.body.classList.add("ph-bg-image-on");
      }
    }

    setupPageHeaderGhost();
  }
  
  // If page header background image is light
  // =========================================
  if (document.querySelector("#page-header.ph-bg-image.ph-bg-image-is-light")) {
    document.body.classList.add("ph-bg-image-is-light-on");
  }
  
  // ================================================================
  // Next project
  // ================================================================
  
  if (document.querySelector(".tt-np-image")) {
    document.body.classList.add("tt-np-image-on");
  }

  const bodyInner = document.getElementById("body-inner");
  if (bodyInner) {
    document.querySelectorAll(".portfolio-interactive-images, .portfolio-interactive-ghost").forEach((element) => {
      bodyInner.appendChild(element);
    });
  }

  const portfolioInteractive = document.querySelector(".portfolio-interactive");
  if (portfolioInteractive?.classList.contains("pi-inline")) {
    document.body.classList.add("pi-inline-on");
  }
  if (portfolioInteractive?.classList.contains("pi-center")) {
    document.body.classList.add("pi-center-on");
  }
  if (portfolioInteractive?.classList.contains("pi-full")) {
    document.body.classList.add("pi-full-on");
  }





// ScrollTrigger animations moved to islands/scroll-animations.js


// ScrollTrigger animations moved to islands/scroll-animations.js





// ================================================================
// NON-CRITICAL INITIALIZATION (Deferred)
// These are deferred to avoid blocking LCP rendering
// ================================================================

function initNonCriticalFeatures() {
    // ================================================================
    // Portfolio interactive
    // ================================================================

    const portfolioInteractive = document.querySelector(".portfolio-interactive");

    const initPortfolioInteractiveHover = () => {
        if (!portfolioInteractive) return;

        const hoverMq = window.matchMedia(HOVER_CAPABLE_LAYOUT);
        let abortController = null;

        const disableHover = () => {
            abortController?.abort();
            abortController = null;
            portfolioInteractive.classList.remove("hovered");
            document.querySelectorAll(".portfolio-interactive-item").forEach((item) => {
                item.classList.remove("pi-item-hover");
                item.querySelector(".pi-item-image video")?.pause();
            });
        };

        const enableHover = () => {
            if (abortController) return;
            abortController = new AbortController();
            const { signal } = abortController;

            document.querySelectorAll(".portfolio-interactive-item").forEach((item) => {
                const hoverTarget = item.querySelector(".pi-item-head") || item.querySelector(".pi-item-title-link");
                if (!hoverTarget) return;

                hoverTarget.addEventListener("mouseenter", () => {
                    portfolioInteractive.classList.add("hovered");
                    item.classList.add("pi-item-hover");
                    item.querySelector(".pi-item-image video")?.play();
                }, { signal });

                hoverTarget.addEventListener("mouseleave", () => {
                    portfolioInteractive.classList.remove("hovered");
                    item.classList.remove("pi-item-hover");
                    item.querySelector(".pi-item-image video")?.pause();
                }, { signal });
            });
        };

        const syncHover = () => {
            if (hoverMq.matches) enableHover();
            else disableHover();
        };

        syncHover();
        hoverMq.addEventListener("change", syncHover);
    };

    initPortfolioInteractiveHover();
    
    // If item image is light (batched)
    // =======================
    const portfolioImages = Array.from(document.querySelectorAll(".pi-item-image"));
    let imageIndex = 0;
    const processPortfolioImages = () => {
        const batch = portfolioImages.slice(imageIndex, imageIndex + 10);
        batch.forEach(image => {
            if (image.classList.contains("pi-item-image-is-light")) {
                image.closest(".portfolio-interactive-item")?.classList.add("pi-item-light-image-on");
            }
        });
        imageIndex += 10;
        if (imageIndex < portfolioImages.length) {
            setTimeout(processPortfolioImages, 0);
        }
    };
    if (portfolioImages.length > 0) {
        processPortfolioImages();
    }




    // ================================================================
    // Portfolio grid
    // ================================================================

    // If "pgi-cap-inside enabled
    // ===========================
    const portfolioGrid = document.querySelector("#portfolio-grid");
    if (portfolioGrid && portfolioGrid.classList.contains("pgi-cap-inside")) {

        // Move "pgi-caption" to inside "pgi-image-wrap" (batched).
        const gridItems = Array.from(document.querySelectorAll(".portfolio-grid-item"));
        let gridIndex = 0;
        const processGridItems = () => {
            const batch = gridItems.slice(gridIndex, gridIndex + 5);
            batch.forEach(item => {
                const caption = item.querySelector(".pgi-caption");
                const imageWrap = item.querySelector(".pgi-image-wrap");
                if (caption && imageWrap) {
                    imageWrap.appendChild(caption);
                }
            });
            gridIndex += 5;
            if (gridIndex < gridItems.length) {
                setTimeout(processGridItems, 0);
            } else {
                // Remove grid item title anchor tag if exist (batched).
                const gridAnchors = Array.from(document.querySelectorAll(".pgi-title a"));
                let anchorIndex = 0;
                const processAnchors = () => {
                    const batch = gridAnchors.slice(anchorIndex, anchorIndex + 5);
                    batch.forEach(anchor => {
                        const parent = anchor.parentNode;
                        while (anchor.firstChild) parent.insertBefore(anchor.firstChild, anchor);
                        parent.removeChild(anchor);
                    });
                    anchorIndex += 5;
                    if (anchorIndex < gridAnchors.length) {
                        setTimeout(processAnchors, 0);
                    }
                };
                if (gridAnchors.length > 0) {
                    processAnchors();
                }
            }
        };
        if (gridItems.length > 0) {
            processGridItems();
        }
    }
    
    // Play video on hover (batched)
    // ====================
    const imageWraps = Array.from(document.querySelectorAll(".pgi-image-wrap"));
    let wrapIndex = 0;
    const processImageWraps = () => {
        const batch = imageWraps.slice(wrapIndex, wrapIndex + 10);
        batch.forEach(wrapper => {
            wrapper.addEventListener("mouseenter", () => {
                wrapper.querySelectorAll("video").forEach(video => video.play());
            });
            wrapper.addEventListener("mouseleave", () => {
                wrapper.querySelectorAll("video").forEach(video => video.pause());
            });
        });
        wrapIndex += 10;
        if (wrapIndex < imageWraps.length) {
            setTimeout(processImageWraps, 0);
        }
    };
    if (imageWraps.length > 0) {
        processImageWraps();
    }
    




    // ================================================================
    // tt-Gallery
    // ================================================================

	// Play video on hover (batched)
	const galleryWraps = Array.from(document.querySelectorAll(".tt-gallery-video-wrap"));
	let galleryWrapIndex = 0;
	const processGalleryWraps = () => {
		const batch = galleryWraps.slice(galleryWrapIndex, galleryWrapIndex + 10);
		batch.forEach(function (wrap) {
			wrap.addEventListener("mouseenter", playVideo);
			wrap.addEventListener("touchstart", playVideo);
			wrap.addEventListener("mouseleave", pauseVideo);
			wrap.addEventListener("touchend", pauseVideo);
		});
		galleryWrapIndex += 10;
		if (galleryWrapIndex < galleryWraps.length) {
			setTimeout(processGalleryWraps, 0);
		}
	};
	if (galleryWraps.length > 0) {
		processGalleryWraps();
	}

	function playVideo() {
		this.querySelectorAll("video").forEach(function (video) {
			video.play();
		});

	}

	function pauseVideo() {
		this.querySelectorAll("video").forEach(function (video) {
			video.pause();
		});

	}

	// Gallery item image zoom on hover (batched)
	const galleryItems = Array.from(document.querySelectorAll(".tt-gallery-item"));
	const gallery = document.querySelector(".tt-gallery");
	if (gallery && gallery.classList.contains("ttga-hover")) {
		let galleryItemIndex = 0;
		const processGalleryItems = () => {
			const batch = galleryItems.slice(galleryItemIndex, galleryItemIndex + 10);
			batch.forEach(function (item) {
				const img = item.querySelector(".tt-gallery-image img");
				if (img) {
					const wrapper = document.createElement('div');
					wrapper.classList.add("tt-gallery-image-hover-zoom");
					img.parentNode.insertBefore(wrapper, img);
					wrapper.appendChild(img);
				}
			});
			galleryItemIndex += 10;
			if (galleryItemIndex < galleryItems.length) {
				setTimeout(processGalleryItems, 0);
			}
		};
		if (galleryItems.length > 0) {
			processGalleryItems();
		}
	}




    // Accordion initialization - moved to accordion component


// ==================================
// Sidebar (classic)
// ==================================

	// If tt-sidebar exist.
	if (document.querySelector(".tt-sidebar")) {
		document.body.classList.add("tt-sidebar-on");
		// If tt-sidebar has class "sidebar-left" add class "sidebar-left-on" to <body>.
		if (document.querySelector(".tt-sidebar").classList.contains("sidebar-left")) {
			document.body.classList.add("tt-sidebar-left-on");
		}

		// If tt-sidebar has class "sidebar-right" add class "sidebar-right-on" to <body>.
		if (document.querySelector(".tt-sidebar").classList.contains("sidebar-right")) {
			document.body.classList.add("tt-sidebar-right-on");
		}
	}




// ==================================
// Scrolling text
// ==================================

    // Scrolling text initialization - moved to scrolling-text component


    // ================================================================
    // Scroll between anchors (uses native browser smooth scrolling) - batched
    // ================================================================

    const anchors = Array.from(document.querySelectorAll('a[href^="#"]:not([href$="#"]):not([href$="#0"])'));
    let anchorIndex = 0;
    const processAnchors = () => {
        const batch = anchors.slice(anchorIndex, anchorIndex + 20);
        batch.forEach(anchor => {
            anchor.addEventListener("click", function (e) {
                e.preventDefault();

                const target = document.querySelector(this.hash);
                if (!target) return;

                let offset = 0;

                // If fixed header position enabled.
                const header = document.getElementById("tt-header");
                if (header && header.classList.contains("tt-header-fixed")) {
                    offset = header.offsetHeight;
                }

                // Use data attribute to set top offset if needed.
                if (this.dataset.offset !== undefined) {
                    offset = parseInt(this.dataset.offset, 10);
                }

                const topY = target.getBoundingClientRect().top + window.pageYOffset - offset;

                window.scrollTo({ top: topY, behavior: 'smooth' });
            });
        });
        anchorIndex += 20;
        if (anchorIndex < anchors.length) {
            setTimeout(processAnchors, 0);
        }
    };
    if (anchors.length > 0) {
        processAnchors();
    }



    // ================================================================
    // Scroll to top - batched
    // ================================================================

    const scrollToTopButtons = Array.from(document.querySelectorAll(".scroll-to-top"));
    scrollToTopButtons.forEach(button => {
        button.addEventListener("click", function (e) {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    });


    // =======================================================================================
    // Defer videos (Youtube, Vimeo)
    // Note: When you have embed videos in your webpages it causes your page to load slower.
    // Deffering will allow your page to load quickly.
    // Source: https://www.feedthebot.com/pagespeed/defer-videos.html
    // =======================================================================================

    function initDeferVideos() {
        const vidDefer = document.getElementsByTagName("iframe");
        Array.from(vidDefer).forEach(iframe => {
            if (iframe.getAttribute("data-src")) {
                iframe.setAttribute("src", iframe.getAttribute("data-src"));
            }
        });
    }

    initDeferVideos();


    // ================================================================
    // Forms - batched
    // ================================================================

    // Remove input placeholder on focus
    const formElements = Array.from(document.querySelectorAll('input, textarea'));
    let formIndex = 0;
    const processFormElements = () => {
        const batch = formElements.slice(formIndex, formIndex + 20);
        batch.forEach(element => {
            element.addEventListener('focus', function() {
                this.dataset.placeholder = this.getAttribute('placeholder');
                this.setAttribute('placeholder', '');
            });

            element.addEventListener('blur', function() {
                this.setAttribute('placeholder', this.dataset.placeholder);
            });
        });
        formIndex += 20;
        if (formIndex < formElements.length) {
            setTimeout(processFormElements, 0);
        }
    };
    if (formElements.length > 0) {
        processFormElements();
    }

    const fileInputs = Array.from(document.querySelectorAll('input[type="file"]'));
    fileInputs.forEach(fileInput => {
        fileInput.addEventListener('fileselect', function(event) {
            const { numFiles, label } = event.detail;
            const input = this.closest('.tt-form-file')?.querySelector('.tt-file-info');
            const log = numFiles > 1 ? numFiles + ' files selected' : label;

            if (input) {
                input.value = log;
            } else {
                if (log) alert(log);
            }
        });
    });




    // Magic cursor: islands/magic-cursor-loader.js → magic-cursor.js on first pointer move

    // Page header background image hover handlers (deferred)
    if (document.querySelector("#page-header.ph-bg-image.ph-bg-image-is-light")) {
        document.querySelectorAll(".ph-bg-image-is-light").forEach(element => {
            element.addEventListener("mouseenter", function () {
                document.body.classList.add("tt-light-bg-hover");
            });
            element.addEventListener("mouseleave", function () {
                document.body.classList.remove("tt-light-bg-hover");
            });
        });
    }

    // ================================================================
    // Miscellaneous
    // ================================================================

    // tt-Button disabled (prevent click)
    // ===================
    document.querySelectorAll('.tt-btn-disabled').forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            return false;
        });
    });

    // Hover fix for iOS
    // ==================
    document.addEventListener('touchstart', (e) => {
        if (e.target instanceof Element) {
            const hoverEvent = new Event('hover'); 
            e.target.dispatchEvent(hoverEvent);
        }
    });

    document.addEventListener('touchend', (e) => {
        if (e.target instanceof Element) {
            const hoverEvent = new Event('hover');
            e.target.dispatchEvent(hoverEvent);
        }
    });
}

// Defer non-critical initialization using requestIdleCallback
if (window.requestIdleCallback) {
    requestIdleCallback(initNonCriticalFeatures, { timeout: 2000 });
} else {
    // Fallback for browsers without requestIdleCallback
    setTimeout(initNonCriticalFeatures, 1000);
}

// Force page scroll position to top on refresh (do not remove!)
// =============================================
window.addEventListener('pagehide', () => {
    window.scrollTo(0, 0);
});

// ==========================================================================
// Template style switch
// NOTE: Remove this code if you do not want to use the template light style.
// ==========================================================================

// Display style switch button
// const bodyInner = document.getElementById('body-inner');
// const styleSwitch = document.createElement('div');
// styleSwitch.className = 'tt-style-switch';
// styleSwitch.innerHTML = '<div class="tt-stsw-dark"><i class="far fa-moon"></i></div><div class="tt-stsw-light"><i class="fas fa-sun"></i></div>';
// bodyInner.prepend(styleSwitch);


// if (document.getElementById('tt-light-style-default')) {
//     // Click on style switch
//     styleSwitch.addEventListener('click', () => {
//         document.body.classList.toggle('tt-light-style-default-on');
//         localStorage.setItem('lightstyle', document.body.classList.contains('tt-light-style-default-on'));
//         location.reload();
//     });

//     // localStorage
//     const lightstyle = localStorage.getItem('lightstyle');
//     if (lightstyle === 'true') {
//         document.body.classList.add('tt-light-style-default-on');
//     } else {
//         document.body.classList.remove('tt-light-style-default-on');
//     }

//     // Toggle light stylesheet
//     if (document.body.classList.contains('tt-light-style-default-on')) {
//         document.getElementById('tt-light-style-default').remove();
//     }
// } else {
//     // Click on style switch
//     styleSwitch.addEventListener('click', () => {
//         document.body.classList.toggle('tt-light-style-on');
//         localStorage.setItem('lightstyle', document.body.classList.contains('tt-light-style-on'));
//         location.reload();
//     });

//     // localStorage
//     const lightstyle = localStorage.getItem('lightstyle');
//     if (lightstyle === 'true') {
//         document.body.classList.add('tt-light-style-on');
//         styleSwitch.classList.add('is-dark');
//     } else {
//         document.body.classList.remove('tt-light-style-on');
//     }

//     // Toggle light stylesheet
//     if (document.body.classList.contains('tt-light-style-on')) {
//         const lightStyle = document.createElement('link');
//         lightStyle.id = 'tt-light-style';
//         lightStyle.rel = 'stylesheet';
//         lightStyle.href = '/assets/css/light-style.css';
//         document.getElementById('tt-themecss').after(lightStyle);
//     } else {
//         const lightStyle = document.getElementById('tt-light-style');
//         if (lightStyle) lightStyle.remove();
//     }
// }

// End template style switch